import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Container } from './styles';

export default function GDPRPanel({ className }) {
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts
        .pop()
        .split(';')
        .shift();
    }
    return false;
  }

  const cookiePermissioned = getCookie('permissioned');
  const cookieToSet = cookiePermissioned === 'allow';

  function gaOptout(allow) {
    if (allow === false) {
      const gaProperty = 'UA-165840316-1';
      const disableStr = `ga-disable-${gaProperty}`;
      document.cookie = `${disableStr}=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/`;
      window[disableStr] = true;
    }
  }

  const date = new Date();
  date.setDate(date.getDate() + 90);

  return (
    <Container className={className} visible={!cookieToSet}>
      <p>
        A <span>Profa. Dra. Priscila Rocco</span> utiliza cookies em seu
        dispositivo para melhorar a navegação no site, analisar o uso do site e
        auxiliar em nossos esforços de marketing, para mais informações acesse a{' '}
        <Link to={`${process.env.PUBLIC_URL}/politica-privacidade`}>
          Política de Privacidade.
        </Link>
      </p>
      <button
        type="button"
        className="btn-cookies"
        onClick={() => {
          gaOptout(!cookieToSet);
          document.cookie = `permissioned=allow; expires=${date.toUTCString()}`;
          document.location.reload();
        }}
      >
        Aceitar
      </button>
    </Container>
  );
}

GDPRPanel.propTypes = {
  className: PropTypes.string.isRequired,
};
